module.exports = __webpack_public_path__ + "media/images/logo-fortaleza-large_branco-8835f48dc1afcc3f08f4cfdc95ebf2eb.png";